import React from "react";

import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

/**
 * Thin stroke lightning bolt (Heroicons-style outline) for the Upgrade CTA.
 * MUI's BoltOutlined reads heavier / different geometry than typical stroke icons.
 */
export function UpgradeBoltIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
      <path
        d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
